module.exports = __webpack_public_path__ + "img/plastic_free.png";